/** The six characters a person can type from the handover QR or display. */
export const HANDOVER_PRESENCE_CODE_LENGTH = 6

/**
 * React Native can leave rejected pasted characters in its native text buffer
 * when the sanitized JS value is identical to the previous state. Keeping the
 * buffer in sync means the person never sees a code different from the one we
 * will actually verify.
 */
export type NativeTextSynchronizer = {
  setNativeProps: (props: { text: string }) => void
}

export function normalizeHandoverPresenceCode(
  text: string,
  nativeInput?: NativeTextSynchronizer | null,
): string {
  const normalized = text
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, HANDOVER_PRESENCE_CODE_LENGTH)

  if (normalized !== text) nativeInput?.setNativeProps({ text: normalized })
  return normalized
}
